import { Helmet } from 'react-helmet-async';
import { useState } from 'react';

import { Container, Grid } from '@mui/material';

import Footer from 'src/components/Commons/Footer';
import { TBreadCrumb } from 'src/types/Breakcrumbs/breadcrumb.model';
import BreakCrumbs from 'src/pages/Breakcum';
import useLanguage from 'src/hooks/Language/useLanguage';
import { PathURL } from 'src/utils/constants/path';
import ProductTable from 'src/components/Products/ProductTable';

function ListProduct() {
  const {
    language: { product }
  } = useLanguage();
  const [currentSearchText] = useState('');

  const breadcrumb: TBreadCrumb[] = [
    { path: PathURL.product.list, name: product.titleHeader },
    { path: '', name: product.titleHeader }
  ];

  return (
    <>
      <Helmet>
        <title>{product.titleHeader}</title>
      </Helmet>
      <Container maxWidth="xl" className="pt-16">
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3}>
          <Grid item xs={12} md={12}>
            {breadcrumb && <BreakCrumbs breadcrumb={breadcrumb} />}
          </Grid>
        </Grid>
        <div className="flex flex-row flex-wrap pt-8">
          <ProductTable searchText={currentSearchText} />
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default ListProduct;
